import React, { useContext, useEffect, useState } from "react";
import About from "../../components/about";
import Section from "../../components/section";
import Speakers from "../../components/speakers";
// import SponsorBox from "../../components/sponsor/sponsorBox";
import Sponsors from "../../components/sponsor/sponsors";
import Context from "../../context/Context";
import { Speaker } from "../../interfaces/interfaces";
import NewHero from "../hero/new";
import ModalCPE from "../../components/modals/cpeModal";
import useEventDetails from "../../hooks/useEventDetails";

const Main = () => {
  const data = useContext(Context);
  const speakers: Speaker[] = data.speakers;
  const { singlePage, sponsors, sponsorLevels, isSpeakerBioEnabled } = data;
  const levels = sponsorLevels ? sponsorLevels : ["diamond"];
  const [sponsorsWithLevels, setSponsorsWithLevels] = useState({});

  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };
  const { virtual } = useEventDetails();
  useEffect(() => {
    const sWithLevels = {};

    levels.map((sponsorLevel) => {
      const sponsorsAtLevel = sponsors.filter(sponsor => sponsor?.sponsorLevel?.toLowerCase() === sponsorLevel);
      sWithLevels[sponsorLevel] = sponsorsAtLevel;
    });

    setSponsorsWithLevels(sWithLevels);
  }, []);

  return (
    <div id="main-container">
      <NewHero />
      {singlePage && (
        <>
          <div className="wrapper">
            <div className="sng-container">
              <div className="child about-bg">
                <Section id="About">
                <About />
                </Section>
              </div>
              <div className="child coloredBg">
                <Section id="Speakers" className="landing-page-speakers">
                  <Speakers speakers={speakers} isSpeakerBioEnabled={isSpeakerBioEnabled} />
                </Section>
                {/*<Section id="BeASponsor" className="become-a-sponsor">
                  <div className="sng-container">
                    <div className="text-content">
                      <h2>Become a Sponsor</h2>
                      <p>For more information about sponsoring AITalks, <br />
                      contact us at <a href="mailto:aitalks.sponsorships@scoopnewsgroup.com?subject=2024 AITalks Sponsorship Inquiry">aitalks.sponsorships@scoopnewsgroup.com</a>.</p>
                      <br />
                      {/* <a href="PDF DOWNLOAD" className="download-sponsor-pdf">Download the PDF</a>
                    </div>
                    {/* <div className="image-content">
                      <img className="mobile-bg-image" src="https://cdn.ems.prod.upgather.com//uploads/AI_Talks_Mobile_Mid_BG_41b7bf0219.png" alt="AITalks background image" />
                    </div> 
                  </div>
                </Section>*/}
              </div>
            </div>
          </div>
          <br />
          {/* <SponsorBox /> */}
          <Section id="Sponsors" className="sponsors-section">
            <Sponsors sponsorsWithLevels={sponsorsWithLevels} />
          </Section>
          {/*<Section id="ctacard" className="card-section">
            <div className="card-inner">
              <div className="card-item">
                <div className="card-logo"><img src="https://cdn.ems.prod.upgather.com/uploads/cta_globe_f4645f0dc7.png" alt="globe" /></div>
                <div className="card-header">CPE</div>
                <div className="card-paragraph">Interested in earning continuing professional education (CPE) credits?<br /><br /></div>
                <div className="card-cta">{ virtual ?(
          <></>
        ):(<>
          
              
              <a onClick={openModal} className="cpe-link">Click here to learn more! &#12299;</a>
              <ModalCPE isOpen={modalOpen} onClose={closeModal}>

              <b className="cpebold">2024 Google Public Sector Summit</b> attendees are eligible to receive continuing professional education (CPE) credits. Attendees can earn a maximum of 4 CPE credits in information technology.<br /><br />
              In order to verify your CPEs, please document your name on the CPE attendance sheet located at the registration desk onsite. Be sure to return to the registration desk to document your time out. If sign in and/or sign out times are not documented, FedScoop is unable to verify your attendance and therefore cannot award CPE credit.<br /><br />
              <b className="cpebold">Additional details:</b><br />
              <b className="cpebold">Delivery Method:</b> Group-Live<br />
              <b className="cpebold">Program Level:</b> Intermediate<br />
              <b className="cpebold">Prerequisites:</b> Previous professional experience in IT and technology is recommended for all participants<br />
              <b className="cpebold">Advance Preparation:</b> No advance preparation necessary<br />
              <b className="cpebold">Contact:</b>  <a href="mailto:kylie.galyen@scoopnewsgroup.com" target="_blank" className="cpe-email">Kylie Galyen</a> for details on obtaining CPE credits at the event.<br /><br />

              <img src="https://sng-client-assets.s3.amazonaws.com/fedscoop/upgather/trellix/2023/cybersecurity-summit/CPElogo.jpg" className="cpe-image" alt="CPE" /><p className="sngcpe">Scoop News Group is registered with the National Association of State Boards of Accountancy (NASBA) as a sponsor of continuing professional education on the National Registry of CPE Sponsors. State boards of accountancy have final authority on the acceptance of individual courses for CPE credit. Complaints regarding registered sponsors may be submitted to the National Registry of CPE Sponsors through its website: <a href="https://www.nasbaregistry.org" target="_blank" className="cpe-nasbar">www.NASBARegistry.org</a>.</p>
              </ModalCPE>
              
        </>)} </div>
              </div>
              
              <div className="card-item">
                <div className="card-logo"><img src="https://cdn.ems.prod.upgather.com/uploads/cta_hands_279944d37b.png" alt="handshake" /></div>
                <div className="card-header">Follow Us</div>
                <div className="card-paragraph">Keep up with the latest Google Cloud news, announcement, and more. Join the conversation on X.</div>
                <div className="card-cta"><a href="https://x.com/googlecloud" target="_blank">Stay connected</a></div>
              </div>
            </div>
            
        </Section>*/}
        </>
      )}
    </div>
  );
};

export default Main;
